export const supportEmail = 'support@spottedzebra.co.uk';
